module.exports = __webpack_public_path__ + "static/media/girasol.048088e8.jpg";